import request from '@/utils/request';

export default class Login {
  // 确认登录
  public static login(param: object) {
    return request.post('/api/login', param);
  }
}
